'use client';

import {
	Card,
	GridItem,
	SimpleGrid,
	Text,
} from '@chakra-ui/react';
import React from 'react';

import { NextImageWrapper } from '@/modules/shared/presentation';

import { useJobDetailContext } from './JobDetail';

export const CompanyGallery = () => {
	const { job } = useJobDetailContext();

	return (
		<Card.Root>
			<Card.Body>
				<SimpleGrid columns={2} gap={4}>
					{job.images.map((img, idx) => (
						<GridItem key={img.url || idx}>
							<NextImageWrapper
								aspectRatio="landscape"
								image={{
									alt: img.caption ?? 'Company image',
									src: img.url ?? 'https://via.placeholder.com/400x250',
								}}
							/>
							<Text mt={2} textStyle="caption">
								{img.caption}
							</Text>
						</GridItem>
					))}
				</SimpleGrid>
			</Card.Body>
		</Card.Root>
	);
};
